<template>
    <div class="divPrincipal">
        <b-modal v-model="show" no-close-on-backdrop :title="titulo" size="bg" class="title">
            <b-form-row v-html="mensagem"></b-form-row>
            <div class="date">{{dtInicial}}</div>
            <template v-slot:modal-footer>
                <div class="divButtons" v-show="!jaLido">
                    <b-form-checkbox v-model="isLido"/>
                    <label for="checkbox">Estou de acordo, não mostrar novamente.</label> 
                </div>
                <div class="row">
                  <b-btn-group class="mr-2">
                    <b-btn block :variant="classe" @click="close">{{ok}}</b-btn>
                  </b-btn-group>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
  export default {
     data () {
    return {
      isLido: false,
      show: false,
    }
  },
    props: {
      tipo: String,
      titulo: String,
      mensagem: { default: '' },
      ok: { default: 'OK' },
      jaLido: { default: false },
      codigoNotificacao: String,
      dtInicial: String
    },
    methods: {
      close() {
        let th = this
        th.show = false
        if(!this.jaLido){
          th.jaLido = false
        }

        if(th.isLido){
          th.$root.$emit('refreshBell', th.codigoNotificacao);
          th.LerNotificacao()
        }
      },
      openModal(){
        this.show = true
        this.isLido = false
      },
      LerNotificacao(){
        let th = this
        th.$api.Notificacao.LerNotificacao(th.codigoNotificacao)
      }
    },
    computed: {
      classe() {
        return 'info'
      }
    }
}
</script>
<style>
.checkbox{
    left: 10px;
    position: absolute;
}
.divPrincipal{
    position: relative;
}
.divButtons{
    left: 15px;
    position: absolute;
    display: flex;
    flex-direction: row;
    bottom: 10%;
}

.title{
  color: black;
}

.date{
  right: 20px;
  color: #8f8f8f;
  bottom: 2px;
  position: absolute;
}
</style>